import {Inject, Injectable} from '@angular/core';
import {ApiResponse, MesConfigService, MesHttpStatusHandlerService, ICommonAppSettings} from 'common-shared';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToInstance} from "class-transformer";
import {ActivityStreamItem} from "../../components/dashboard/activity-stream-item";

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends MesConfigService {

  constructor(@Inject('persistStorage') private persistStorage, mesHttpStatusHandlerService: MesHttpStatusHandlerService) {
    super(mesHttpStatusHandlerService);
  }

  responseTest(): Observable<ApiResponse<any>> {
    return this.getSingle<any>({
      action: 'ResponseTest'
    });
  }

  responseExceptionTest(): Observable<ApiResponse<any>> {
    return this.getSingle<any>({
      action: 'ResponseExceptionTest'
    });
  }

  progressMessagesTest(): Observable<ApiResponse<any>> {
    return this.getSingle<any>({
      action: 'ProgressTest'
    });
  }

  progressMessagesForUserTest(): Observable<ApiResponse<any>> {
    return this.getSingle<any>({
      action: 'ProgressForUserTest'
    });
  }

  getLastActivities(types: number[], showOnlyByMe: boolean = false): Observable<ActivityStreamItem[]> {
    return this.getList<ActivityStreamItem>({
      action: 'GetLastActivities'
    }, {types: types, showOnlyByMe: showOnlyByMe}).pipe(map(value => {
      return plainToInstance(ActivityStreamItem, value.data);
    }));
  }

  setLogTimingData(logging: boolean) {
    return this.getSingle<boolean>({action: 'SetLogTimingData'}, {logging: logging})
      .pipe(map(value => value.data));
  }
}
